import FavouritesExpired from './FavouritesExpired';
export default FavouritesExpired;
